import Typography from "@mui/material/Typography"
import { BRAND } from "@/features/landing/content"

import React from "react"
import logo from "@/assets/images/pngs/lyp.png"

import { Stack, Box } from "@mui/material"

export default function SitemarkIcon() {
  return (
    <Stack gap={1} direction="row" alignItems="center">
      <Box width={28} height={28}>
        <img src={logo} alt="ListYourProduct logo" width={28} height={28} />
      </Box>
      <Typography
        variant="h6"
        noWrap
        sx={theme => ({
          fontWeight: 800,
          letterSpacing: "-0.5px",
          color: "primary.main",
          mr: 2,
          ...theme.applyStyles("dark", { color: "primary.light" })
        })}>
        {BRAND.name}
      </Typography>
    </Stack>
  )
}
